if (!customElements.get('localization-form')) {
  class LocalizationForm extends customElements.get('dropdown-input') {
    constructor() {
      super();
    }

    init() {
      super.init();

      this.form = this.querySelector('form');
      this.flag = this.querySelector('summary [data-flag]');

      this.select.addEventListener('change', (e) => {
        const activeButton = this.querySelector('button:disabled');

        this.flag.innerHTML = activeButton.firstElementChild.innerHTML;
        this.close();
        this.form.submit();
      });
    }
  }

  customElements.define('localization-form', LocalizationForm);
}
